<template>
  <div class="panel panel-default">
    <div class="panel-heading">
      <h5>
        {{ headline }}
      </h5>
    </div>

    <div class="panel-body">
      <form @submit.prevent="$emit('submit', data)">
        <TextFormGroup
            v-model="data.name"
            name="name"
            label="Name"
            help-text="The name of the article label."
            :error="(errors.name || [])[0]"
        />

        <SelectFormGroup
            v-model="data.icon"
            name="icon"
            label="Icon"
            help-text="The icon of the article label."
            :error="(errors.icon || [])[0]"
            :options="iconOptions"
        />

        <SubmitFormGroup button-class="btn-black"/>
      </form>
    </div>
  </div>
</template>

<script>
import store from '@/store'
import SelectFormGroup from '@/vendor/forms/FormGroups/Block/Select'
import SubmitFormGroup from '@/vendor/forms/FormGroups/Block/Submit'
import TextFormGroup from '@/vendor/forms/FormGroups/Block/Text'

export default {
  components: {SelectFormGroup, SubmitFormGroup, TextFormGroup},

  props: {
    headline: {
      required: true,
      type: String
    },

    initial: {
      required: false,
      type: Object,
      default: () => ({})
    },

    errors: {
      required: true,
      type: Object
    }
  },

  data() {
    return {
      data: {...this.initial},

      shared: store
    }
  },

  computed: {
    iconOptions() {
      return [
        {value: 'podcast', label: 'Podcast'},
        {value: 'quote', label: 'Quote'},
      ]
    }
  }
}
</script>